import { MsalBroadcastService } from '@azure/msal-angular';
import { EventType } from '@azure/msal-browser';
import { AuthErrorCodes } from '@core/enums/auth-error-codes.enum';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

export function getB2CError(msalBroadcastService: MsalBroadcastService): Observable<string> {
  return msalBroadcastService.msalSubject$.pipe(
    filter((event) => event.eventType === EventType.LOGIN_FAILURE),
    map((event) => {
      const isUnregisteredPhoneNumber = event.error.message.includes(
        AuthErrorCodes.B2CUserDoesNotExistError,
      );

      const isregisteredPhoneNumber = event.error.message.includes(
        AuthErrorCodes.B2CUserDoesxistError,
      );

      if (isUnregisteredPhoneNumber) {
        return $localize`This phone number is not registered`;
      } else if (isregisteredPhoneNumber) {
        // eslint-disable-next-line max-len
        return $localize`This phone number is already registered. Please use different phone number`;
      } else {
        $localize`Login failure`;
      }
    }),
  );
}
